import * as React from 'react'
import type { ReactNode } from 'react'
import * as s from '../DeckView.css'

/**
 * Collapsible group-section header (caret, label, row count) — shared by
 * DeckView and TimelineView so the two grouping UIs stay visually consistent.
 */
export function GroupSectionHeader({
  label,
  count,
  collapsed,
  onToggle,
}: {
  label: ReactNode
  count: number
  collapsed: boolean
  onToggle: () => void
}) {
  return (
    <button
      type="button"
      className={s.deckGroupHeader}
      onClick={onToggle}
      aria-expanded={!collapsed}
    >
      <span className={`${s.deckGroupCaret} ${collapsed ? s.deckGroupCaretCollapsed : ''}`}>
        <svg width={12} height={12} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 16 5 9h14l-7 7z" />
        </svg>
      </span>
      {label}
      <span className={s.deckGroupCount}>{count}</span>
    </button>
  )
}
